import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, Handshake, User, Rocket, ShieldCheck, Globe } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/lib/services-data";

const iconMap = { Building2, Handshake, User, Rocket, ShieldCheck, Globe };

export const ServicesOverview = () => {
  const services = SERVICES;

  return (
    <section className="bg-white" data-testid="services-overview">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <Reveal>
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
              Services
            </div>
            <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
              Everything a First-Time Founder needs to{" "}
              <span className="hl-yellow">start right</span>.
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Building2;
            return (
              <Reveal delay={i * 60} key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="group block h-full bg-white border border-[#EAEAEA] rounded-2xl p-7 hover:border-[#0F1115] transition-colors relative overflow-hidden flex flex-col items-center text-center"
                  data-testid={`service-card-${s.slug}`}
                >
                  <div className="absolute top-0 left-0 h-1 w-0 bg-[#FDD805] group-hover:w-full transition-[width] duration-500" />
                  <div className="w-12 h-12 rounded-xl bg-[#FFF9E6] flex items-center justify-center">
                    <Icon size={22} className="text-[#0F1115]" />
                  </div>
                  <h3 className="mt-5 font-display text-[22px] font-bold text-[#0F1115]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-[#1C1F26] leading-relaxed">
                    {s.short}
                  </p>
                  <div className="mt-5 text-[13px] font-bold text-[#0F1115] inline-flex items-center gap-1.5">
                    Learn more <ArrowUpRight size={14} />
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
